import {
  ProtectionAttackType,
  ProtectionResult,
  SafetyLevel
} from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
import { logger } from "utilities/src/logger/logger";
export function parseSafetyLevel(safetyLevel) {
  if (!safetyLevel) {
    return void 0;
  }
  const validSafetyLevels = Object.values(SafetyLevel);
  if (validSafetyLevels.includes(safetyLevel)) {
    return safetyLevel;
  } else {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseSafetyLevel",
      `Invalid safetyLevel from REST TokenRankings query: ${safetyLevel}`
    );
    return void 0;
  }
}
export function parseProtectionInfo(protectionInfo) {
  if (!protectionInfo) {
    return void 0;
  }
  let protectionResult;
  const validProtectionResults = Object.values(ProtectionResult);
  if (validProtectionResults.includes(protectionInfo.result.toUpperCase())) {
    protectionResult = protectionInfo.result.toUpperCase();
  } else {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseProtectionInfo",
      `Invalid protectionResult from REST TokenRankings query: ${protectionInfo.result}`
    );
    return void 0;
  }
  const validAttackTypes = Object.values(ProtectionAttackType);
  const attackTypes = protectionInfo.attackTypes.filter((at) => validAttackTypes.includes(at.toUpperCase())).map((at) => at.toUpperCase());
  if (attackTypes.length !== protectionInfo.attackTypes.length) {
    logger.warn(
      "uniswap/data/rest/utils.ts",
      "parseProtectionInfo",
      `Invalid attackTypes in REST TokenRankings query: ${protectionInfo.attackTypes}`
    );
  }
  return { attackTypes, result: protectionResult };
}
